<nx-card class="viewer">
  <nx-card-header>
    <page-form-header [model]="model" [titleProperty]="'name'"></page-form-header>
  </nx-card-header>

  <page-form-tool-bar
    [saveSupplier]="save()"
    [cancelSupplier]="cancel()"
    >

  </page-form-tool-bar>

  @if (!model.id && partners) {
    <forms-contract-form [model]="model" [partners]="partners" [distributors]="distributorForUser" [asDistributor]="true"></forms-contract-form>
  }
  @if (model.id) {
    <forms-edit-contract-form [model]="model" [editableType]="editableType" [asDistributor]="true"></forms-edit-contract-form>
  }

</nx-card>
